import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerLibroContabileModalComponent } from './worker-libro-contabile-modal';

export const WorkerLibroContabileModalModule: string = ng
    .module('worker-libro-contabile-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerLibroContabileModalComponent', WorkerLibroContabileModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-libro-contabile-modal/worker-libro-contabile-modal.module.ts